__turbopack_context__.v({
  "emblaSlide": "styles-module__BGzbfq__emblaSlide",
});
